import React from 'react';

import { formatScorePercentage, scoreBandColor } from '../AuditScoreSummary/bands';
import { ChipContainer, ScoreChip } from './styles';

export type AuditScoreChipProps = {
  percentage: number | null | undefined;
  label?: string;
  /** `filled` is the legacy pill: band-coloured fill, white text. */
  variant?: 'outlined' | 'filled';
  'data-testid'?: string;
};

/** A score of `0` is real; only `null` means nothing was scorable, and renders no chip at all. */
const AuditScoreChip = ({
  percentage,
  label,
  variant = 'outlined',
  'data-testid': testId,
}: AuditScoreChipProps): React.ReactElement => {
  const scored = percentage !== null && percentage !== undefined;
  const filled = variant === 'filled';

  return (
    <ChipContainer data-testid={testId} data-score-state={scored ? 'scored' : 'unscored'}>
      {scored && (
        <ScoreChip $color={scoreBandColor(percentage)} $filled={filled}>
          {label ? `${label} | ` : ''}
          {formatScorePercentage(percentage)}
        </ScoreChip>
      )}
    </ChipContainer>
  );
};

export default AuditScoreChip;
